import MainLayout from '@/common/components/layouts/MainLayout';
import { VehicleImagePreview } from '@/modules/adjusterReportModules/adjusterReport/pages/ImagePreview/vehicleImagePreview';
import {
  INITIAL_ADJUSTER_IMAGES_LINKS,
  INITIAL_IMAGES_LINKS,
} from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { useNavigate, useParams } from 'react-router-dom';

export default function InitialVisitLocalImagePreviewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const navigateToRepeatCapturing = () => {
    navigate(
      INITIAL_ADJUSTER_IMAGES_LINKS.INITIAL_VISIT_VEHICLE_IMAGES.edit(id!),
      {
        replace: true,
      },
    );
  };
  const BackToImagesTab = () => {
    navigate(INITIAL_IMAGES_LINKS.ADJUSTER_IMAGES(id!), { replace: true });
  };
  return (
    <MainLayout title="بازدید اولیه / تصاویر" header="onlyTitleHeader">
      <VehicleImagePreview
        BackToImagesTab={BackToImagesTab}
        navigateToRepeatCapturing={navigateToRepeatCapturing}
        userType="initial"
      />
    </MainLayout>
  );
}
